/* eslint-disable functional/no-expression-statement, functional/immutable-data */
/* eslint-disable  functional/no-conditional-statement */
import winston, { format } from 'winston';
import configuration from '@price-point/configuration';
import BrowserTransport from './setup/BrowserTransport';

export default function setup() {
  winston.level = 'info';
  if (typeof window === 'undefined') {
    const env = configuration('NODE_ENV');
    const appName = configuration('APP_NAME');
    const addInfo = format((info) => {
      // eslint-disable-next-line no-param-reassign
      info.appName = appName;
      // eslint-disable-next-line no-param-reassign
      info.message = JSON.stringify(info.message);
      return info;
    });
    winston.level = configuration('LOG_LEVEL', 'info');

    if (env === 'development' || env === 'test') {
      winston.level = 'debug';
      const consoleTransport = new winston.transports.Console({
        format: format.combine(format.timestamp(), addInfo(), format.cli()),
      });
      winston.add(consoleTransport);
    } else {
      const consoleTransport = new winston.transports.Console({
        format: format.combine(format.timestamp(), format.errors(), addInfo(), format.json()),
      });
      winston.add(consoleTransport);
    }
  } else {
    const consoleTransport = new BrowserTransport({
      format: format.combine(format.timestamp(), format.cli()),
      level: 'info',
    });
    winston.add(consoleTransport);
  }
}
